/**
* api接口统一管理
*/
// var HOST = "http://192.168.1.50:8000"
var HOST = "https://restapi.10qu.com.cn"
import { get, post, put, delet } from './http'
var api = {
    //图片上传
    uploadPic: (param, header) => post(HOST + `/image_to_url/`, param, header),
    // 密码登录
    loginPassword: (param) => post(HOST + `/username_login/`, param),
    //获取验证码
    sendAuthCode: (param) => post(HOST + `/sms_code/`, param),
    //验证码登录
    verificationJump: (param) => post(HOST + `/mobile_login/`, param),
    //注册
    passwordRegister: (param) => post(HOST + `/username_register/`, param),
    //验证验证码是否正确
    verificationCode: (param) => post(HOST + `/mobile_smscode/`, param),
    //忘记密码重置密码
    resetPasswordByAuthCode: (param) => put(HOST + `/mobile_update_pwd/`, param),
    //修改密码
    modifyPassword: (param, header) => put(HOST + `/update_pwd/`, param, header),
    //完善个人信息
    updateUserBasicInfo: (param, header) => put(HOST + `/user_info/`, param, header),
    //查询用户头像昵称
    queryUserNickImg: (param, header) => get(HOST + `/user_info/`, param, header),
    //查询清单条数
    navnumbar: (param, header) => get(HOST + `/todo_profile/?show_expired=1`, param, header),
    //添加清单
    addtodo: (param, header) => post(HOST + `/todo_from/ `, param, header),
    //四象限
    fourquadr: (param, header) => get(HOST + `/user_todo/?type=${param}`, '', header),
    //四象限分别请求
    fourquadrcation: (param, header) => get(HOST + `/user_todo/?type=${param}`, '', header),
    //查询自定义请求
    customquadrcation: (param, header) => get(HOST + `/user_todo/?todo_from_id=${param}`, '', header),
    //查询全部待办清单
    alltodo: (param, header) => get(HOST + `/todo_summarize/`, param, header),
    //今天
    todaytwo: (param, header) => get(HOST + `/todo_search/?task_time=${param}`, '', header),
    //已过期的
    unday: (param, header) => get(HOST + `/todo_type_profile/?flag=expired`, param, header),
    //未来七天的
    futureday: (param, header) => get(HOST + `/todo_type_profile/`, param, header),
    //发布清单
    releasetodo: (param, header) => post(HOST + `/todo/`, param, header),
    //修改清单
    modifytodo: (id, param, header) => put(HOST + `/todo/${id}/`, param, header),
    //删除清单 
    deletetodo: (param, header) => delet(HOST + `/todo/${param}/`, '', header),
    //删除分类 
    deleteClassification: (param, header) => delet(HOST + `/todo_from/${param}/`, '', header),
    putClassification: (param, header) => put(HOST + `/todo_from/${param.id}/`, param, header),
    //全部自定义清单内容
    qblist: (param, header) => get(HOST + `/todo_category_profile/`, param, header),
    //点击已完成 
    completed: (param, header) => put(HOST + `/update_todo_status/`, param, header),
    //周视图
    weekday: (param, header) => get(HOST + `/query_todo_week_view/?week_date=${param}`, '', header),
    //月视图
    monthday: (param, header) => get(HOST + `/search_todo_month_view/?keywords=${param}`, '', header),
    timeaxis: (param, header) => get(HOST + `/search_todo_month/?keywords=${param}`, '', header),
    //  查询存在清单的日期
    selecttime: (param, header) => get(HOST + `/query_todo_month_init/`, param, header),



}
export default api;